import { render, staticRenderFns } from "./classifyChoice.vue?vue&type=template&id=090a5784&scoped=true"
import script from "./classifyChoice.vue?vue&type=script&lang=js"
export * from "./classifyChoice.vue?vue&type=script&lang=js"
import style0 from "./classifyChoice.vue?vue&type=style&index=0&id=090a5784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a5784",
  null
  
)

export default component.exports